import React from 'react';

import * as S from './Spinner.styles';

const Spinner = ({ theme }) => {
    return (
        <S.Spnr theme={theme}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </S.Spnr>
    )
}

export default Spinner;